import './CRUDTeamMember.scss';
import Component from './CRUDTeamMember';
export default Component;
